import { useMemo } from "react";
import { CameraTool } from "@treegram/tools-camera";
import { createViewerTool, ViewerTool } from "@/hooks/viewer/use-viewer.ts";

export const useMeasureOverviewTools = (): ViewerTool[] =>
    useMemo<ViewerTool[]>(() => [
        createViewerTool({
            key: "cameraTool",
            factory: (ctx) => new CameraTool(ctx.viewer),
        }),
    ], []);

export default useMeasureOverviewTools;
